var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "comment"
  }, [_c('div', {
    staticClass: "comment__desktop-avatar"
  }, [_c('ColorAvatar', {
    attrs: {
      "name": _vm.data.name,
      "size": "40"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "comment__complain",
    on: {
      "click": function ($event) {
        return _vm.$emit('report', true);
      }
    }
  }, [_c('div', {
    staticClass: "icon-warning"
  })]), _vm._v(" "), _c('div', {
    staticClass: "comment__content"
  }, [_c('div', {
    staticClass: "comment__user"
  }, [_c('div', {
    staticClass: "comment__mobile-avatar"
  }, [_vm.data.name ? _c('ColorAvatar', {
    attrs: {
      "name": _vm.data.name,
      "size": "40"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "comment__info"
  }, [_vm.data.name ? _c('div', {
    staticClass: "comment__title-user"
  }, [_vm._v("\n          " + _vm._s(_vm.data.name) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm.data.date ? _c('div', {
    staticClass: "comment__date-user"
  }, [_vm._v("\n          " + _vm._s(_vm.data.date) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _vm.data.rate ? _c('div', {
    staticClass: "comment__rating-wrap"
  }, [_c('TSProductRating', {
    attrs: {
      "is-active": _vm.data.rate,
      "show-status": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.data.text ? _c('div', {
    staticClass: "comment__text p p_lh21"
  }, [_vm._v("\n      " + _vm._s(_vm.data.text) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('Toggle', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$data$like, _vm$data$dislike, _vm$data$like2, _vm$data$dislike2;

        var onClick = _ref.onClick,
            isActive = _ref.isActive;
        return [_c('div', {
          staticClass: "comment__tools"
        }, [_vm.slots.default ? _c('div', {
          staticClass: "comment__tool"
        }, [_c('div', {
          staticClass: "comment__answer-button",
          on: {
            "click": function ($event) {
              return _vm.onAnswer(onClick);
            }
          }
        }, [_vm._v("\n            Ответить\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "comment__tool"
        }, [_c('ReviewsThumbs', {
          attrs: {
            "like": (_vm$data$like = _vm.data.like) === null || _vm$data$like === void 0 ? void 0 : _vm$data$like.count,
            "dislike": (_vm$data$dislike = _vm.data.dislike) === null || _vm$data$dislike === void 0 ? void 0 : _vm$data$dislike.count,
            "active-like": (_vm$data$like2 = _vm.data.like) === null || _vm$data$like2 === void 0 ? void 0 : _vm$data$like2.active,
            "active-dislike": (_vm$data$dislike2 = _vm.data.dislike) === null || _vm$data$dislike2 === void 0 ? void 0 : _vm$data$dislike2.active
          },
          on: {
            "positive": function ($event) {
              return _vm.$emit('positive', {
                id: _vm.data.id,
                reviewId: _vm.reviewId
              });
            },
            "negative": function ($event) {
              return _vm.$emit('negative', {
                id: _vm.data.id,
                reviewId: _vm.reviewId
              });
            }
          }
        })], 1)]), _vm._v(" "), isActive ? _c('div', {
          staticClass: "comment__response"
        }, [_vm._t("default", null, {
          "data": _vm.data,
          "toggleShow": onClick
        })], 2) : _vm._e()];
      }
    }], null, true)
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }